import { Pane } from '@leverege/ui-elements'
import { TitleBar } from '@leverege/ui-plugin'
import React, { useMemo, useState } from 'react'

import HourlyUsage from './HourlyUsage'

export default function HourlyAnalytics( { data, loading, ...rest } ) {
  const [ selectedStation ] = useState( null )

  // const { timezone } = useSharedContext()

  const stations = useMemo( () => {
    return Array.from( data.bins.values() )
      .reduce( ( prev, curr ) => {
        if ( curr.obj ) {
          prev.push( curr.obj )
        }

        return prev
      }, [] )
  }, [ data?.bins ] )

  const stationData = selectedStation ?
    data.bins.get( selectedStation ).events :
    Array.from( data.bins.values() )
      .reduce( ( prev, curr ) => {
        return [
          ...prev,
          ...curr?.events || []
        ]
      }, [] )
  
  return (
    <Pane variant="card">
      <TitleBar
        variant="analyticsCardTitle|cardTitle"
        icon={loading ? 'fa fa-spin fa-circle-o-notch' : undefined}
        title="Pets Serviced Per Hour" />
      <HourlyUsage
        {...rest}
        data={stationData}
        stations={stations}
        type="dogInStation"
        fill="#D9E6F7"
        stroke="#4381D9" />
    </Pane>
  )
}
